import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './sentry.setup';

import { App, registerDemoCaseSources } from '#app';
import { Loader, SentryErrorBoundary, logger } from '#shared';

import { initStore } from '#app/store';

const root = createRoot(document.getElementById('root') as HTMLElement);

registerDemoCaseSources();

const { store, persistor } = initStore();

root.render(
  <StrictMode>
    {/* SpecRef: ARCH-005 */}
    {/* Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#1-sentryerrorboundary-placement */}
    {/* Outermost boundary: reports to Sentry, shows a fallback, never blank. */}
    <SentryErrorBoundary showDialog={false}>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={<Loader />} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </SentryErrorBoundary>
  </StrictMode>,
);
logger.info(`App started`);
